import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Contexts/auth";
import styles from './Login.module.css';
import CondText from '../../Components/SideBar/assets/icons/condbot-login.png';
import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';

const Login = () => {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const { authenticated, login } = useContext(AuthContext);
  const [authorizedError, setAuthorizedError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    await login(email, password);
    validateReturnLogin();
  };

  useEffect(() => {
    if (authorizedError) {
      const timer = setTimeout(() => {
        setAuthorizedError(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [authorizedError]);

  function validateReturnLogin() {
    if (!authenticated) {
      setAuthorizedError(true);
    } else {
      setAuthorizedError(false);
    }
  }

  return (
    <LayoutDefault>
      <div className={styles.imageContent}>
        <img src={CondText} alt="Imagem explicativa sobre o CondoBot" className={styles.imageImg} />
      </div>
      <div>
        <div className={styles.loginPanel}>
          <div className={styles.login}>
            <div className={styles.siteDescription}>
              <h1>Login</h1>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.field}>
                <input
                  placeholder="Email"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className={styles.field}>
                <input
                  placeholder="Senha"
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className={styles.responseLogin}>
                {authorizedError && (
                  <span className={styles.error}>E-mail ou senha inválidos</span>
                )}
              </div>
              <div className={styles.actions}>
                <button className={styles.buttonLogin} type="submit">Entrar</button>
              </div>
            </form>
            <div className={styles.changePassword}>
              <button onClick={() => navigate("/forgot-password")} className={styles.linkButton}>
                Esqueceu a senha?
              </button>
            </div>
            <form className={styles.form}>
              <div className={styles.actions}>
                <button className={styles.createAccount} onClick={() => navigate("/create-account")} type="submit">Criar nova conta</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </LayoutDefault>
  );
};

export default Login;
